import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Vault: FC<SvgProps> = ({ size = 181, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={200}
      viewBox="0 0 181 200"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_57_25974)">
        <g clipPath="url(#clip1_57_25974)">
          <mask id="path-3-inside-1_57_25974" fill="white">
            <path d="M0.444092 18.4422C0.444092 8.50103 8.50297 0.442139 18.4441 0.442139H162.556C172.497 0.442139 180.556 8.50101 180.556 18.4421V162.496C180.556 172.437 172.497 180.496 162.556 180.496H18.4441C8.50296 180.496 0.444092 172.437 0.444092 162.496V18.4422Z" />
          </mask>
          <path
            d="M0.444092 18.4422C0.444092 8.50103 8.50297 0.442139 18.4441 0.442139H162.556C172.497 0.442139 180.556 8.50101 180.556 18.4421V162.496C180.556 172.437 172.497 180.496 162.556 180.496H18.4441C8.50296 180.496 0.444092 172.437 0.444092 162.496V18.4422Z"
            fill="url(#paint0_linear_57_25974)"
          />
          <path
            d="M-0.555908 18.4421C-0.555908 7.94873 7.95068 -0.557861 18.4441 -0.557861H162.556C173.05 -0.557861 181.556 7.94873 181.556 18.4421H179.556C179.556 9.0533 171.945 1.44214 162.556 1.44214H18.4441C9.05525 1.44214 1.44409 9.0533 1.44409 18.4421H-0.555908ZM181.556 162.496C181.556 172.989 173.05 181.496 162.556 181.496H18.4441C7.95068 181.496 -0.555908 172.989 -0.555908 162.496H1.44409C1.44409 171.885 9.05525 179.496 18.4441 179.496H162.556C171.945 179.496 179.556 171.885 179.556 162.496H181.556ZM18.4441 181.496C7.95068 181.496 -0.555908 172.989 -0.555908 162.496V18.4421C-0.555908 7.94873 7.95068 -0.557861 18.4441 -0.557861V1.44214C9.05525 1.44214 1.44409 9.0533 1.44409 18.4421V162.496C1.44409 171.885 9.05525 179.496 18.4441 179.496V181.496ZM162.556 -0.557861C173.05 -0.557861 181.556 7.94873 181.556 18.4421V162.496C181.556 172.989 173.05 181.496 162.556 181.496V179.496C171.945 179.496 179.556 171.885 179.556 162.496V18.4421C179.556 9.0533 171.945 1.44214 162.556 1.44214V-0.557861Z"
            fill="url(#paint1_linear_57_25974)"
            fillOpacity="0.32"
            mask="url(#path-3-inside-1_57_25974)"
          />
          <rect
            x="24.1714"
            y="24.1618"
            width="132.657"
            height="132.615"
            rx="18"
            fill="url(#paint2_linear_57_25974)"
            fillOpacity="0.05"
          />
          <rect
            x="24.6714"
            y="24.6618"
            width="131.657"
            height="131.615"
            rx="17.5"
            stroke="url(#paint3_linear_57_25974)"
            strokeOpacity="0.15"
          />
          <rect
            x="19.8574"
            y="38.178"
            width="8.62813"
            height="30.7278"
            rx="4.31406"
            fill="#3C4137"
          />
          <rect
            x="20.3574"
            y="38.678"
            width="7.62813"
            height="29.7278"
            rx="3.81406"
            stroke="url(#paint4_linear_57_25974)"
            strokeOpacity="0.15"
          />
          <rect
            x="19.8574"
            y="112.032"
            width="8.62813"
            height="30.7278"
            rx="4.31406"
            fill="url(#paint5_linear_57_25974)"
          />
          <rect
            x="20.3574"
            y="112.532"
            width="7.62813"
            height="29.7278"
            rx="3.81406"
            stroke="url(#paint6_linear_57_25974)"
            strokeOpacity="0.15"
          />
          <mask id="path-11-inside-2_57_25974" fill="white">
            <path d="M133.641 90.4691C133.641 114.287 114.326 133.596 90.5002 133.596C66.6743 133.596 47.3596 114.287 47.3596 90.4691C47.3596 66.6509 66.6743 47.3424 90.5002 47.3424C114.326 47.3424 133.641 66.6509 133.641 90.4691ZM58.5219 90.4691C58.5219 108.125 72.8391 122.437 90.5002 122.437C108.161 122.437 122.479 108.125 122.479 90.4691C122.479 72.8136 108.161 58.5011 90.5002 58.5011C72.8391 58.5011 58.5219 72.8136 58.5219 90.4691Z" />
          </mask>
          <path
            d="M133.641 90.4691C133.641 114.287 114.326 133.596 90.5002 133.596C66.6743 133.596 47.3596 114.287 47.3596 90.4691C47.3596 66.6509 66.6743 47.3424 90.5002 47.3424C114.326 47.3424 133.641 66.6509 133.641 90.4691ZM58.5219 90.4691C58.5219 108.125 72.8391 122.437 90.5002 122.437C108.161 122.437 122.479 108.125 122.479 90.4691C122.479 72.8136 108.161 58.5011 90.5002 58.5011C72.8391 58.5011 58.5219 72.8136 58.5219 90.4691Z"
            fill="#F7F7F7"
            fillOpacity="0.05"
            stroke="url(#paint7_linear_57_25974)"
            strokeOpacity="0.15"
            strokeWidth="2"
            mask="url(#path-11-inside-2_57_25974)"
          />
          <rect
            x="88.8826"
            y="63.5149"
            width="3.23555"
            height="53.9084"
            rx="1.61777"
            fill="url(#paint8_linear_57_25974)"
          />
          <rect
            x="63.5374"
            y="92.0864"
            width="3.2345"
            height="53.9258"
            rx="1.61725"
            transform="rotate(-90 63.5374 92.0864)"
            fill="url(#paint9_linear_57_25974)"
          />
          <rect
            width="3.23502"
            height="53.9171"
            rx="1.61751"
            transform="matrix(0.707221 -0.706993 0.707221 0.706993 70.5476 71.1929)"
            fill="url(#paint10_linear_57_25974)"
          />
          <rect
            width="3.23502"
            height="53.9171"
            rx="1.61751"
            transform="matrix(0.707221 0.706993 -0.707221 0.706993 108.679 69.4448)"
            fill="url(#paint11_linear_57_25974)"
          />
          <g filter="url(#filter0_f_57_25974)">
            <ellipse
              cx="90.7698"
              cy="90.1995"
              rx="22.3792"
              ry="22.372"
              fill="#C4FAC3"
              fillOpacity="0.15"
            />
          </g>
          <ellipse
            cx="146.583"
            cy="93.1645"
            rx="6.47109"
            ry="6.469"
            fill="#3E4338"
          />
          <path
            d="M152.554 93.1645C152.554 96.4609 149.881 99.1335 146.583 99.1335C143.285 99.1335 140.612 96.4609 140.612 93.1645C140.612 89.8681 143.285 87.1955 146.583 87.1955C149.881 87.1955 152.554 89.8681 152.554 93.1645Z"
            stroke="url(#paint12_linear_57_25974)"
            strokeOpacity="0.15"
          />
          <rect
            x="143.347"
            y="91.0082"
            width="6.47109"
            height="21.5633"
            rx="3.23555"
            fill="#3C4137"
          />
          <rect
            x="143.847"
            y="91.5082"
            width="5.47109"
            height="20.5633"
            rx="2.73555"
            stroke="url(#paint13_linear_57_25974)"
            strokeOpacity="0.15"
          />
          <path
            d="M108.335 90.4691C108.335 100.316 100.35 108.298 90.5001 108.298C80.65 108.298 72.6653 100.316 72.6653 90.4691C72.6653 80.6227 80.65 72.6403 90.5001 72.6403C100.35 72.6403 108.335 80.6227 108.335 90.4691Z"
            fill="#3D4137"
            stroke="#4E5345"
          />
          <rect
            x="89.9607"
            y="72.1403"
            width="1.07852"
            height="3.2345"
            rx="0.539258"
            fill="url(#paint14_linear_57_25974)"
          />
          <rect
            x="91.0393"
            y="108.798"
            width="1.07852"
            height="3.2345"
            rx="0.539258"
            transform="rotate(-180 91.0393 108.798)"
            fill="url(#paint15_linear_57_25974)"
          />
          <rect
            width="1.07834"
            height="3.23502"
            rx="0.539171"
            transform="matrix(0.707221 -0.706993 0.707221 0.706993 78.0972 77.2152)"
            fill="url(#paint16_linear_57_25974)"
          />
          <rect
            x="72.1653"
            y="91.0082"
            width="1.07817"
            height="3.23555"
            rx="0.539084"
            transform="rotate(-90 72.1653 91.0082)"
            fill="url(#paint17_linear_57_25974)"
          />
          <rect
            x="108.835"
            y="89.93"
            width="1.07817"
            height="3.23555"
            rx="0.539084"
            transform="rotate(90 108.835 89.93)"
            fill="url(#paint18_linear_57_25974)"
          />
          <rect
            width="1.07834"
            height="3.23502"
            rx="0.539171"
            transform="matrix(-0.707221 0.706993 -0.707221 -0.706993 104.875 101.921)"
            fill="url(#paint19_linear_57_25974)"
          />
          <rect
            width="1.07834"
            height="3.23502"
            rx="0.539171"
            transform="matrix(0.707221 0.706993 -0.707221 0.706993 103.034 76.4529)"
            fill="url(#paint20_linear_57_25974)"
          />
          <rect
            width="1.07834"
            height="3.23502"
            rx="0.539171"
            transform="matrix(-0.707221 -0.706992 0.707221 -0.706993 77.7812 103.222)"
            fill="url(#paint21_linear_57_25974)"
          />
          <path
            d="M90.1537 80.8263C90.3076 80.5597 90.6925 80.5597 90.8464 80.8263L92.0215 82.861C92.1756 83.1276 91.9831 83.461 91.6752 83.461H89.3249C89.017 83.461 88.8245 83.1276 88.9786 82.861L90.1537 80.8263Z"
            fill="#575C4F"
          />
          <ellipse
            cx="90.5001"
            cy="90.4691"
            rx="7.54961"
            ry="7.54717"
            fill="#575C4F"
          />
          <path
            d="M97.5497 90.4691C97.5497 94.361 94.3936 97.5163 90.5001 97.5163C86.6065 97.5163 83.4504 94.361 83.4504 90.4691C83.4504 86.5772 86.6065 83.4219 90.5001 83.4219C94.3936 83.4219 97.5497 86.5772 97.5497 90.4691Z"
            stroke="#F7F7F7"
            strokeOpacity="0.05"
          />
          <path
            d="M92.1571 90.4691C92.1571 91.3837 91.4154 92.1254 90.5 92.1254C89.5847 92.1254 88.843 91.3837 88.843 90.4691C88.843 89.5545 89.5847 88.8128 90.5 88.8128C91.4154 88.8128 92.1571 89.5545 92.1571 90.4691Z"
            fill="#D9FFD9"
            stroke="#5F6457"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_57_25974"
          x="-31.6094"
          y="-32.1724"
          width="244.758"
          height="244.744"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="50"
            result="effect1_foregroundBlur_57_25974"
          />
        </filter>
        <linearGradient
          id="paint0_linear_57_25974"
          x1="90.5002"
          y1="0.442139"
          x2="90.5002"
          y2="160.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#282C21" />
          <stop offset="1" stopColor="#282C21" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_57_25974"
          x1="90.5001"
          y1="0.442139"
          x2="90.5002"
          y2="176.183"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="1" stopColor="#F7F7F7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_57_25974"
          x1="90.5001"
          y1="24.1618"
          x2="90.5001"
          y2="163.245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="1" stopColor="#F7F7F7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_57_25974"
          x1="90.5001"
          y1="24.1618"
          x2="90.5001"
          y2="168.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="1" stopColor="#F7F7F7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_57_25974"
          x1="14.7345"
          y1="38.178"
          x2="30.9046"
          y2="64.8672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" stopOpacity="0" />
          <stop offset="1" stopColor="#F7F7F7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_57_25974"
          x1="24.1715"
          y1="112.032"
          x2="24.1715"
          y2="142.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C4137" />
          <stop offset="1" stopColor="#3C4137" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_57_25974"
          x1="24.1715"
          y1="112.032"
          x2="24.1715"
          y2="142.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="1" stopColor="#F7F7F7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_57_25974"
          x1="123.934"
          y1="129.283"
          x2="50.3532"
          y2="42.7367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="1" stopColor="#F7F7F7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_57_25974"
          x1="90.5003"
          y1="63.5149"
          x2="90.5003"
          y2="117.423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E5445" />
          <stop offset="0.154248" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="0.846846" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_57_25974"
          x1="65.1546"
          y1="92.0864"
          x2="65.1546"
          y2="146.012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E5445" />
          <stop offset="0.154248" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="0.846846" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_57_25974"
          x1="1.61751"
          y1="-1.92823e-09"
          x2="1.61751"
          y2="53.9171"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E5445" />
          <stop offset="0.154248" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="0.846846" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_57_25974"
          x1="1.61751"
          y1="-1.92823e-09"
          x2="1.61751"
          y2="53.9171"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E5445" />
          <stop offset="0.154248" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="0.846846" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_57_25974"
          x1="153.054"
          y1="100.173"
          x2="141.464"
          y2="85.8832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="1" stopColor="#F7F7F7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_57_25974"
          x1="151.167"
          y1="114.728"
          x2="137.153"
          y2="85.3443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="1" stopColor="#F7F7F7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_57_25974"
          x1="90.5"
          y1="72.1403"
          x2="90.5"
          y2="75.3748"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_57_25974"
          x1="91.5786"
          y1="108.798"
          x2="91.5786"
          y2="112.032"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_57_25974"
          x1="0.539171"
          y1="-1.15694e-10"
          x2="0.539171"
          y2="3.23502"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_57_25974"
          x1="72.7044"
          y1="91.0082"
          x2="72.7044"
          y2="94.2437"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_57_25974"
          x1="109.374"
          y1="89.93"
          x2="109.374"
          y2="93.1656"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_57_25974"
          x1="0.539171"
          y1="-1.15694e-10"
          x2="0.539171"
          y2="3.23502"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_57_25974"
          x1="0.539171"
          y1="-1.15694e-10"
          x2="0.539171"
          y2="3.23502"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_57_25974"
          x1="0.539171"
          y1="-1.15694e-10"
          x2="0.539171"
          y2="3.23502"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0858176" stopColor="#4E5445" stopOpacity="0" />
          <stop offset="1" stopColor="#4E5445" />
        </linearGradient>
        <clipPath id="clip0_57_25974">
          <rect x="0.5" width="180" height="200" rx="4" fill="white" />
        </clipPath>
        <clipPath id="clip1_57_25974">
          <rect
            x="0.444092"
            y="0.442139"
            width="180.112"
            height="180.054"
            rx="18"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Vault;
